import storageRepository from "./storageRepository";
import moment from "moment";

export default {
  load() {
    let config = storageRepository.get("config");
    if (config) {
      // 云端/旧数据可能缺省；与仓库默认值对齐，避免被当成 false
      if (!("moveCompletedTaskToBottom" in config)) {
        config.moveCompletedTaskToBottom = true;
      }
      if (!("moveCompletedSubTaskToBottom" in config)) {
        config.moveCompletedSubTaskToBottom = true;
      }
      if (!("autoReorderTasks" in config)) {
        config.autoReorderTasks = false;
      }
      if (!("notesEditorMode" in config) || (config.notesEditorMode !== "light" && config.notesEditorMode !== "focus")) {
        config.notesEditorMode = "light";
      }
      return config;
    } else {
      let default_config = {
        darkTheme: false,
        customList: true,
        calendar: true,
        firstTimeOpen: true,
        language: "en",
        // 展示/升级提示用的版本来自服务端 APP_VERSION（/api/me.appVersion）
        version: "",
        checkUpdates: true,
        columns: 5,
        customColumns: 5,
        zoom: 100,
        calendarHeight: "calc(50% - 50px)",
        notificationOnStartup: true,
        notificationSound: "pop",
        openOnStartup: true,
        runInBackground: true,
        moveOldTasks: true,
        dateToShowInitialDonateModal: moment().add(15, "d").format("YYYY-MM-DD"),
        InitialDonateModalShown: false,
        mainDividerPosition: 1,
        darkTrayIcon: false,
        importing: false,
        compactView: true,
        startCalendarYesterday: false,
        notificationIndicator: true,
        autoReorderTasks: false,
        moveCompletedTaskToBottom: true,
        moveCompletedSubTaskToBottom: true,
        fullscreenToDoModal: false,
        weekStartOnMonday: true,
        defaultCalendarView: "day",
        notesEditorMode: "light",
        lastDayOpened: moment().format("YYYY-MM-DD")
      };
      storageRepository.set("config", default_config);
      return default_config;
    }
  },
  update(config) {
    storageRepository.set("config", config);
  },
};
